import { ApplicationSettings } from "@app/constants";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SettingsApi extends HOAApiBase {

    constructor() {
        super('SettingsApi')
    }

    public getSettings(): Observable<ApplicationSettings> {
        return this.http.get<ApplicationSettings>(this.createUrl('HOAPass', '/settings'));
    }
}


